<script lang="ts">
    import type { IAddress, IContact } from 'wdom/services/contacts'

    interface Props {
        contact: IContact | IAddress
    }

    let { contact }: Props = $props()

    let visual: string | undefined = $state()
    $effect(() => {
        if (contact.country === 'CA' && contact.postal_code) {
            const cup = contact.postal_code.toUpperCase()
            visual = `${cup.slice(0, 3)} ${cup.slice(3)}`
        } else if (contact.postal_code) {
            visual = contact.postal_code
        } else {
            visual = undefined
        }
    })
</script>

{#if visual}{visual}{/if}
